import { combineReducers } from 'redux';
import {
  JOBS_LIST_FETCHED, JOB_UPDATED, ADD_JOB, ADD_JOB_ITEM, REMOVE_JOB_ITEM, DUPLICATE_RUNSHEET, RUNSHEET_FETCHED,
  UPDATE_JOB_SEQUENCE
} from '../types';

const DEFAULT_JOB = {
  externalId: '',
  seq: 0,
  customerName: '',
  stop: {
    location: { id: 0, type: { code: '' } }
  },
  type: '',
  notes: '',
  jobItems: [],
};

// update job location type reducer, remove from JobForm state
const byId = (state = {}, action) => {
  switch (action.type) {
    case JOBS_LIST_FETCHED:
      return {
        ...state,
        ...action.payload.entities.jobs
      };
    case RUNSHEET_FETCHED: {
      return {
        ...state,
        ...action.payload.entities.jobs
      };
    }
    case ADD_JOB:
      const { jobExternalId, sequence } = action.payload;
      return {
        ...state,
        [jobExternalId]: { ...DEFAULT_JOB, externalId: jobExternalId, seq: sequence }
      };
    case JOB_UPDATED: {
      const { externalId, attributes } = action.payload;
      let job = state[externalId];

      return {
        ...state,
        [externalId]: {
          ...job,
          ...attributes,
          jobItems: job.jobItems
        }
      };
    }
    case 'UPDATE_JOB_LOCATION_TYPE': {
      const { jobExternalId, locationType } = action.payload;
      let job = state[jobExternalId];
      let updatedJob = Object.assign({}, job);
      updatedJob.stop.location = { ...DEFAULT_JOB.stop.location, type: { code: locationType } };

      return {
        ...state,
        [jobExternalId]: {...updatedJob}
      };
    }
    case 'UPDATE_JOB_LOCATION': {
      const { jobExternalId, locationId } = action.payload;
      let job = state[jobExternalId];
      let updatedJob = Object.assign({}, job);
      updatedJob.stop.location.id = locationId;

      return {
        ...state,
        [jobExternalId]: {...updatedJob}
      };
    }
    case ADD_JOB_ITEM: {
      const { jobExternalId, jobItem } = action.payload;
      const job = state[jobExternalId];

      return {
        ...state,
        [jobExternalId]: {
          ...job,
          jobItems: job.jobItems.concat(jobItem)
        }
      }
    }
    case REMOVE_JOB_ITEM: {
      const { jobExternalId, index } = action.payload;
      const job = state[jobExternalId];
      return {
        ...state,
        [jobExternalId]: {
          ...job,
          jobItems: [
            ...job.jobItems.slice(0, index),
            ...job.jobItems.slice(index + 1)
          ]
        }
      }
    }
    case DUPLICATE_RUNSHEET: {
      return {
        ...state,
        ...action.payload.entities.jobs
      };
    }
    case UPDATE_JOB_SEQUENCE: {
      const { jobExternalId, sequence } = action.payload;
      const job = state[jobExternalId];

      return {
        ...state,
        [jobExternalId]: {
          ...job,
          seq: sequence
        }
      }
    }
    default:
      return state
  }
};

const allIds = (state = [], action) => {
  switch (action.type) {
    case ADD_JOB:
      return [...state, action.payload.jobExternalId];
    default:
      return state;
  }
};

export default combineReducers({byId, allIds});



// WEBPACK FOOTER //
// ./src/reducers/jobsReducer.js